import { useAnalyticsPushEvent } from '../../../analytic/analytic.context';
import bem from '../../../utils/bem';
import decodeString from '../../../utils/decodeString';
import isExternalURL from '../../../utils/isExternalURL';

const FooterMenu = ({ heading, list, id, analyticData }) => {
  const pushAnalyticEvent = useAnalyticsPushEvent();
  const baseClass = 'footer-menu';
  const onClickAnalyticHandler = (e, text) => {
    if (analyticData)
      pushAnalyticEvent({
        ...analyticData,
        component_name: '[B46] Links',
        link_text: text,
        link_url: e.target.href,
      });
    return undefined;
  };
  const menuItems = () => {
    return list.map((link, index) => {
      const targetAttr = isExternalURL(link.url)
        ? { target: '_blank', rel: 'noreferrer' }
        : {};
      return (
        <li key={id ? `${id}-${index}` : index}>
          <a
            className={bem('link', [], baseClass)}
            href={link.url}
            {...targetAttr}
            onClick={(e) => onClickAnalyticHandler(e, link.title)}
          >
            {link.title}
          </a>
        </li>
      );
    });
  };

  return (
    <div className={bem(baseClass, [], '', ['flex', 'flex-col'])}>
      {heading && (
        <h5 className={bem('heading', [], baseClass)}>
          {decodeString(heading)}
        </h5>
      )}

      <ul className={bem('list', [], baseClass, ['flex', 'flex-col'])}>
        {menuItems()}
      </ul>
    </div>
  );
};

export default FooterMenu;
